import { Heading, Text, Button, Image, Flex, Stack, Box } from '@chakra-ui/react';
import viewQuestionnaires from '../../assets/new-images/backgrounds/view-questionnaires.svg';
import { companyHeader } from '../../assets/new-images';
import { Link, useParams } from 'react-router-dom';
import { Select } from '../Input';
import { useEffect, useMemo } from 'react';

export default function CompanyHeader({
 companies,
 selectedCompanyId,
 setSelectedCompanyId,
 removeEditButton = false,
}) {

 const { id: idCompany } = useParams();
 const selectedCompany = companies?.find(
  (companie) => companie?.c_id_company === +selectedCompanyId
 );

 const formattedCNPJ = selectedCompany?.c_cnpj?.replace(
  /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
  '$1.$2.$3/$4-$5'
 );

 const companieOptions = useMemo(() => {
  if (!companies?.length || companies?.length <= 1) {
   return [];
  }

  const uniqueCompanies = new Map();
  companies.forEach((company) => {
   if (!uniqueCompanies.has(company.c_id_company)) {
    uniqueCompanies.set(company.c_id_company, company);
   }
  });

  return Array.from(uniqueCompanies.values()).map((company) => ({
   label: company.c_name,
   value: String(company.c_id_company),
  }));
 }, [companies]);

 const handleCompanyChange = (e) => {
  const selectedValue = e.target.value;
  if (companieOptions.some((option) => option.value === selectedValue)) {
   setSelectedCompanyId(selectedValue);
  }
 };

 useEffect(() => {
  if (
   companieOptions.length &&
   !companieOptions.some((option) => option.value === selectedCompanyId)
  ) {
   setSelectedCompanyId(companieOptions[0]?.value);
  }
 }, [companieOptions, selectedCompanyId, setSelectedCompanyId]);

 return (
  <Box
   p='32px'
   bgImage={viewQuestionnaires}
   bgRepeat='no-repeat'
   bgSize='cover'
   borderRadius='12px'
   overflow='hidden'
  >
   <Flex align='center' h='56px' w='100%'>
    <Box flexShrink={0} display='inline-flex'>
     <Image src={companyHeader} alt='' height='56px' mr='16px' />
     <Stack spacing='8px'>
      <Heading as='h2' fontSize='24px' color='#00B2EF'>
       {selectedCompany?.c_name}
      </Heading>
      <Text color='white' lineHeight='22px'>
       {formattedCNPJ}
      </Text>
     </Stack>
    </Box>

    <Flex flex='1 1 auto' justifyContent='flex-end' gap='6'>
     <Box display='inline-block'>
      {companieOptions?.length > 1 && selectedCompanyId && (
       <Select
        defaultValue={selectedCompanyId}
        value={selectedCompanyId}
        onChange={handleCompanyChange}
        width='366px'
        h='56px'
        bg='#F5F5FB'
        options={companieOptions}
       />
      )}
     </Box>
     {!removeEditButton && (
      <Flex alignItems='center' justifyContent='center'>
       <Button
        as={Link}
        to={`/registration/company?id=${idCompany}`}
        variant='primary'
        width='110px'
        height='56px'
       >
        Editar
       </Button>
      </Flex>
     )}
    </Flex>
   </Flex>
  </Box>
 );
}
